/**
 * @format
 */
import React, { useCallback, useMemo, useState } from 'react';
import {
  ActivityIndicator,
  Platform,
  Image,
  View,
  Text,
  StyleSheet,
} from 'react-native';
import { Rating } from 'react-native-ratings';
import FastImage from 'react-native-fast-image';
import config from '../../lib/config';

interface Props {
  imageStyle: any;
  uri: string;
  buisnessName: string;
  stars?: number;
  numReviews?: number;
}

const ThumbtackItem = (props: Props | any) => {
  const { imageStyle, uri, stars, numReviews, buisnessName } = props;
  let { resizeMode } = props;
  if (!resizeMode || Platform.OS === 'web') {
    resizeMode = 'cover';
  } else {
    resizeMode = FastImage.resizeMode.cover;
  }
  const [loading, setIsLoading] = useState(true);
  // console.log(`ZT IMAGE for ${uri}`);

  const itemImage = useMemo(() => {
    if (Platform.OS === 'web') {
      return <Image source={{ uri }} style={styles.image} {...props} />;
    } else {
      return (
        <FastImage
          source={{ uri }}
          style={styles.image}
          onLoadStart={() => {
            setIsLoading(true);
          }}
          onLoadEnd={() => {
            setIsLoading(false);
          }}
        >
          <ActivityIndicator
            animating={loading}
            size="large"
            color={'#cccccc'}
            style={imageStyle}
          />
        </FastImage>
      );
    }
  }, [uri, imageStyle, loading, props]);

  return (
    <View style={styles.mainView}>
      <View style={styles.headerView}>
        <Text style={styles.featureHeading}>{buisnessName}</Text>
      </View>
      <View style={styles.bodyView}>
        <View style={styles.imageView}>{itemImage}</View>
        <View style={styles.bodyInfoView}>
          <Text style={styles.subSectionHeading}>
            {stars ? `${stars.toFixed(1)} ` : '0.0 '}
            <Rating
              readonly
              startingValue={stars}
              imageSize={17}
              type="custom"
              ratingColor="#FEBE14"
            />
          </Text>
          <Text style={styles.subSectionHeading}>
            {numReviews
              ? `(${numReviews}) ${numReviews === 1 ? 'Review' : 'Reviews'}`
              : '(0) Reviews'}
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainView: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerView: {
    marginBottom: 10,
    flex: 1,
    flexWrap: 'wrap',
  },
  featureHeading: {
    fontSize: config.theme.headingFontSize,
    fontWeight: config.theme.headingFontWeight,
    color: config.theme.headingTextColor,
    marginBottom: 10,
    maxWidth: '80%',
  },
  subSectionHeading: {
    fontSize: 18,
    color: config.theme.advert.subSectionHeadingTextColor,
    fontWeight: '700',
  },
  bodyView: {
    display: 'flex',
    flexDirection: 'row',
  },
  imageView: {
    flex: 1,
    justifyContent: 'center',
    margin: 'auto',
  },
  image: {
    height: 100,
    width: 100,
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 5,
    borderColor: '#CCE1FF',
  },
  bodyInfoView: {
    flex: 1,
    justifyContent: 'flex-start',
  },
});

export default ThumbtackItem;
